import { Reveal, SectionHead } from './Reveal';
import { CarFront, FileWarning, Gavel, Clock3, ArrowRight } from 'lucide-react';

const PROBLEMS = [
  {
    icon: CarFront,
    problem: 'Impound threats on the road',
    detail: 'Commercial fleet owners and private car drivers face vehicle impound and license suspension for long-pending challans.',
    solution: 'Priority legal disposal before impound or blacklist action hits your RC.',
  },
  {
    icon: FileWarning,
    problem: 'Fake or erroneous e-challans',
    detail: 'Wrong number plates and portal errors mean challans issued for vehicles you never drove.',
    solution: 'We gather evidence and file a legal dispute to cancel erroneous challans.',
  },
  {
    icon: Gavel,
    problem: 'Court summons for old challans',
    detail: 'Years-old pending challans escalate into court notices and appearance demands.',
    solution: 'Our advocates appear in Virtual Court and Lok Adalat on your behalf — you stay home.',
  },
  {
    icon: Clock3,
    problem: 'No time for court queues',
    detail: 'Taking a day off work to stand in long court lines just to settle one fine.',
    solution: '100% online handling over WhatsApp. Official receipt delivered to you digitally.',
  },
];

export default function ValueMatrix() {
  return (
    <section className="py-20 lg:py-28 bg-white" data-testid="value-matrix-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHead
          eyebrow="Why Drivers Reach Out"
          title="Don't Drive With Unresolved Challans"
          sub="Every pending challan is a legal risk on wheels. Here is how Settalkar removes it — lawfully."
        />

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          {PROBLEMS.map(({ icon: Icon, problem, detail, solution }, i) => (
            <Reveal key={problem} delay={(i % 2) * 0.1}>
              <div
                className="h-full rounded-2xl border border-slate-200 bg-[#F8FAFC] p-7 sm:p-8 transition-all duration-300 hover:border-brand-blue/30 hover:shadow-xl hover:shadow-brand-blue/10"
                data-testid={`value-matrix-card-${i + 1}`}
              >
                <div className="flex items-start gap-4">
                  <span className="shrink-0 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-white border border-slate-200 text-brand-blue shadow-sm">
                    <Icon size={22} strokeWidth={2.2} />
                  </span>
                  <div>
                    <h3 className="font-display text-xl sm:text-2xl font-bold text-brand-ink leading-snug">{problem}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-500">{detail}</p>
                  </div>
                </div>
                <div className="mt-5 rounded-xl bg-brand-blue/5 border border-brand-blue/10 px-4 py-3.5">
                  <p className="flex items-start gap-2 text-sm font-semibold text-brand-blue">
                    <ArrowRight size={16} strokeWidth={2.5} className="mt-0.5 shrink-0 text-brand-orange" />
                    <span>
                      <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-brand-orange block mb-0.5">
                        The Settalkar Fix
                      </span>
                      {solution}
                    </span>
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
